import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'negativeToParens',
})
export class NegativeToParensPipe implements PipeTransform {
    transform(value: string | number, args?: any): any {
        if (!value) {
            return value;
        }
        value = value.toString();
        return value.charAt(0) === '-' ? '(' + value.substring(1, value.length) + ')' : value;
    }
}
